import classNames from 'classnames'
import { forwardRef, ReactElement, RefObject, useImperativeHandle, useRef } from 'react'

import { PositionChildProps, PositionHandle } from '../types'
import { usePosition, UsePositionParams } from './usePosition'

interface PositionProps extends Omit<UsePositionParams, 'overlayRef'> {
  className: string
  children: (props: PositionChildProps, ref: RefObject<HTMLElement>) => ReactElement
}

export const Position = forwardRef<PositionHandle, PositionProps>(
  ({ className, children, ...positionParams }, ref) => {
    const childRef = useRef<HTMLElement>(null)
    const { positionClassName, positionLeft, positionTop } = usePosition({
      ...positionParams,
      overlayRef: childRef,
    })

    useImperativeHandle(ref, () => ({
      get child() {
        return childRef.current
      },
    }))

    return children(
      {
        className: classNames(className, positionClassName),
        left: positionLeft,
        top: positionTop,
      },
      childRef,
    )
  },
)

Position.displayName = 'Position'
